import { render, staticRenderFns } from "./UrnRepositoryOrder.vue?vue&type=template&id=76cc32e4&scoped=true&"
import script from "./UrnRepositoryOrder.vue?vue&type=script&lang=js&"
export * from "./UrnRepositoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./UrnRepositoryOrder.vue?vue&type=style&index=0&id=76cc32e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cc32e4",
  null
  
)

export default component.exports